import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  password = {};
  passwordForm: UntypedFormGroup;
  submitted = false;
  passwordIsValid = false;

  constructor(private auth: AuthenticationService,
              private _router: Router,
              private _formBuilder: UntypedFormBuilder,
              private http: HttpClient) {
  }

  ngOnInit() {
    this.passwordForm = this._formBuilder.group({
      newPassword: ['', [Validators.required]],
      confirmNewPassword: ['', Validators.required]
    });
  }

  invalidConfirmation() {
    return (this.passwordForm.value.confirmNewPassword !== ''
      && this.passwordForm.get('newPassword').value !== this.passwordForm.get('confirmNewPassword').value);
  }

  onSubmit() {
    this.submitted = true;
    if (this.passwordForm.invalid || !this.validLength() || this.invalidConfirmation()) {
      return;
    }
    this.changePassword();
  }

  validLength() {
    return !!this.passwordForm.get('newPassword').value && this.passwordForm.get('newPassword').value.length >= 8;
  }

  get control() {
    return this.passwordForm.controls;
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }

  changePassword() {
    this.password['password'] = this.passwordForm.get('newPassword').value;
    this.changePasswordRequest(this.auth.userAuthenticated.id, this.password).subscribe(
      () => {
        this._router.navigate(['/']);
        this.auth.logoutUser();
      }
    );
  }

  changePasswordRequest(userId, newPassword) {
    return this.http.put(environment.baseUrlWs + '/api/users/' + userId + '/edit', newPassword);
  }
}
